<template>
	<div
		v-b-visible="onPanelVisible"
		class="panel partners-overview theme-image"
		:style="headerStyle"
	>
		<div class="container">
			<div v-if="isHeaderVisible" class="panel_header">
				<div class="row align-items-end">
					<div v-if="block.block_title" class="col-12">
						<h2>{{ block.block_title }}</h2>
					</div>
				</div>
			</div>
			<div class="partners_overview">
				<ul v-if="block.items.length !== 0" class="partners_list row">
					<li
						v-for="(item, index) in block.items"
						:key="index"
						class="col-12 col-md-12 col-lg-6"
					>
						<div class="partner_about_block">
							<div class="partner_about_block_top">
								<p v-if="item.title" class="title title-lg" v-html="item.title" />
								<p v-if="item.description" class="title">
									{{ item.description }}
								</p>
								<ul
									v-if="item.links.length !== 0"
									class="link-list duo-column"
								>
									<li
										v-for="(link, key) in item.links"
										:key="key"
									>
										<a
											v-if="link.title && link.url"
											:href="link.url"
										>
											{{ link.title }}
										</a>
									</li>
								</ul>
							</div>
							<div class="partner_about_block_bottom">
								<button
									v-if="item.video_url"
									class="btn btn-primary btn-icon icon-video"
									@click="playVideo(item.video_url)"
								>
									{{ $t('watchVideo') }}
								</button>

								<a
									v-if="item.button.is_chat"
									id="main_speakers2_jivosite_top"
									onclick="return jivo_api.open(),!1"
									href="javascript:void(0)"
									class="btn btn-secondary"
									role="button"
								>{{ $t('ChatWithAdvisor') }}</a>
								<a
									v-else-if="item.button.text && item.button.link"
									:href="item.button.link"
									class="btn btn-secondary"
								>{{ item.button.text }}</a>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<CoolLightBox
			:items="videosSource"
			:full-screen="true"
			:index="indexVideosSource"
			@close="indexVideosSource = null"
		/>
	</div>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import panel from '~/mixins/panel';

export default {
	name: 'PanelSpeakersNights2',
	components: {
		CoolLightBox,
	},
	mixins: [panel],
	props: ['block'],
	data() {
		return {
			headerStyle: null,
			videosSource: [{}],
			indexVideosSource: null,
		};
	},
	methods: {
		playVideo(videoUrl) {
			this.videosSource = [{
				src: videoUrl,
			}];
			this.indexVideosSource = 0;
		},
		onPanelVisible(visible) {
			if (visible) {
				this.headerStyle = this.block.image.length !== 0 ? `background-image:url('${this.block.image.src}')` : "background-image: url('/frontimg/bg_speaker_nights2_60.jpg')";
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~/assets/styles/components/home/panel-partners-overview";
</style>
